import { useParamsContext } from '../../contexts/ParamsContext';
import { usePlanAccess } from '../../plans/usePlanAccess';
import { SALONFLOW_FEATURES } from '../../plans/salonflowPlans';
import type { SalonFlowFeatureKey } from '../../plans/salonflowPlans';
import { ChartLine, Gauge, Package, ShoppingBag, Users, UsersRound } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export const dashboardItems: Array<{
    key: string;
    label: string;
    icon: LucideIcon;
    feature: SalonFlowFeatureKey;
}> = [
    { key: 'executivo', label: 'Executivo', icon: ChartLine, feature: SALONFLOW_FEATURES.DASHBOARD_EXECUTIVE },
    { key: 'vendas', label: 'Vendas', icon: ShoppingBag, feature: SALONFLOW_FEATURES.DASHBOARD_SALES },
    { key: 'clientes', label: 'Clientes', icon: UsersRound, feature: SALONFLOW_FEATURES.DASHBOARD_EXECUTIVE },
    { key: 'time', label: 'Time', icon: Users, feature: SALONFLOW_FEATURES.DASHBOARD_EXECUTIVE },
    { key: 'estoque', label: 'Estoque', icon: Package, feature: SALONFLOW_FEATURES.DASHBOARD_STOCK },
    { key: 'basico', label: 'Resumo', icon: Gauge, feature: SALONFLOW_FEATURES.DASHBOARD_BASIC },
];

export default function DashboardNav() {
    const { action, setParams } = useParamsContext();
    const { hasFeature } = usePlanAccess();
    const availableItems = dashboardItems.filter((item) => hasFeature(item.feature));
    const current = availableItems.some((item) => item.key === action)
        ? action
        : availableItems[0]?.key;

    return (
        <nav className="sf-dashboard-navigation" aria-label="Visões do dashboard">
            <div className="flex w-max min-w-full gap-1">
                {availableItems.map((item) => {
                    const isActive = current === item.key;
                    return (
                        <button
                            key={item.key}
                            type="button"
                            aria-current={isActive ? 'page' : undefined}
                            onClick={() => setParams({ action: item.key, id: '' })}
                            className={`sf-dashboard-nav-item shrink-0 flex items-center justify-center gap-2 rounded-xl px-3 py-2 text-sm font-medium transition ${
                                isActive ? 'is-active' : ''
                            }`}
                        >
                            <item.icon aria-hidden="true" className={isActive ? 'sf-accent-text' : 'text-base-content/60'} />
                            <span>{item.label}</span>
                        </button>
                    );
                })}
            </div>
        </nav>
    );
}
